<div class="header row gap">
  <h1 class="title">Création d'une nouvelle organisation</h1>
  <app-icon button type="close"
            (click)="close()"></app-icon>
</div>

<section>
  <form [formGroup]="newOrganizationForm" (submit)="validate(true)">
    <app-input type="organization"
               formControlName="name"
               title="Nom de l'organisation"
               [error]="nameTaken"
               error-message="Nom déjà utilisé"
               placeholder="ex: Organisation A"></app-input>
    <app-radio-buttons
      *ngIf="isAdmin"
      formControlName="gotManagedSubscription"
      title="Ajouter une formule ?"
    ></app-radio-buttons>
    <ng-container *ngIf="gotManagedSubscription && isAdmin">
      <app-info>
        <p>
          Comparez les offres 2026 avant de choisir.
          <u class="pointer" (click)="goToCompanyOffers()">Voir le comparatif</u>
        </p>
      </app-info>
      <app-input
        title="Formule"
        [dropdownData]="managedFormulaNames"
        formControlName="managedSubscriptionPlan"
      ></app-input>
      <app-input
        title="Date de début"
        formControlName="managedSubscriptionStartsAt"
        type="date"
      ></app-input>
      <app-input
        title="Nombre de collaborateurs"
        formControlName="managedSubscriptionSeatCount"
        type="number"
        placeholder="1"
      ></app-input>
      <app-info>
        <p>Les crédits complémentaires pourront être ajoutés après la création de l'organisation.</p>
      </app-info>
      <div class="managed-offer-summary" *ngIf="selectedManagedOfferCard as selectedOffer">
        <p class="managed-offer-kicker">{{ selectedOffer.kicker }}</p>
        <h3>{{ selectedOffer.planCode === 'wetalk-plus' ? 'We talk Plus' : selectedOffer.planCode === 'wetalk-coach' ? 'We talk coach' : 'We talk Basic' }}</h3>
        <p>{{ selectedOffer.summary }}</p>
        <p class="managed-offer-credit">{{ selectedOffer.creditSummary }}</p>
        <div class="managed-offer-highlights">
          <span *ngFor="let highlight of selectedOffer.highlights">{{ highlight }}</span>
        </div>
      </div>
    </ng-container>
    <app-radio-buttons formControlName="gotPilot" title="Ajouter un pilote ?"></app-radio-buttons>
    <app-input #pilotInputElement *ngIf="gotPilot" [searchOptionEnable]="true" (addOption)="addPilot()" [dropdownData]="existingTalkerNames"
               formControlName="pilot" type="user" (searchPilot)="onPilotSearch($event)"></app-input>
    <div *ngIf="!parent">
      <app-radio-buttons formControlName="gotParent" title="Filiale d'une autre organisation ? "></app-radio-buttons>
      <app-input *ngIf="gotParent"
                 formControlName="parent" type="organization"
                 placeholder="ex: Parent"
                 [dropdownData]="existingNames"
      ></app-input>
      <app-radio-buttons formControlName="gotChildren"
                         title="Organisation mère d'autres organisations ? "></app-radio-buttons>
      <app-checkmarks *ngIf="gotChildren" [checkboxes]="childrenCheckboxes" [isFemaleWord]="true"
                      item-name="Organisation sélectionnée"
                      (changeSelection)="updateChildrenSelection($event)"></app-checkmarks>
    </div>

    <app-radio-buttons *ngIf="!gotManagedSubscription" formControlName="gotUnits" title="Ajouter des crédits ?"></app-radio-buttons>
    <div *ngIf="gotUnits && !gotManagedSubscription">
      <app-input formControlName="units" type="number" title="Crédits alloués" placeholder="0"></app-input>
      <app-input title="Transférer depuis une autre organisation" formControlName="addUnitsFrom" type="organization"
                 [dropdownData]="existingNamesWithUnits"></app-input>
    </div>
    <app-radio-buttons formControlName="gotQuota"
                       title="Ajouter un quota de parcours par collaborateur ?"></app-radio-buttons>
    <app-input *ngIf="gotQuota" formControlName="talkerQuota" type="number" title="Quota par talker"
               placeholder="illimité"></app-input>

    <app-radio-buttons formControlName="gotForbiddenThematics"
                       title="Autoriser à ses collaborateurs seulement certaines thématiques ?"></app-radio-buttons>
    <app-checkmarks *ngIf="gotForbiddenThematics"
                    [checkboxes]="allowedThematicsCheckboxes" [isFemaleWord]="true"
                    (changeSelection)="updateAllowedThematicsSelection($event)"
                    item-name="Thématique autorisée"></app-checkmarks>


    <app-radio-buttons formControlName="gotForbiddenOrganizations"
                       title="Interdire à ses collaborateurs de rencontrer des collaborateurs de certaines organisations lors des parcours ?"></app-radio-buttons>
    <div *ngIf="gotForbiddenOrganizations">
      <app-checkmarks [checkboxes]="forbiddenOrganizationsCheckboxes" [isFemaleWord]="true"
                      item-name="Organisation interdite"
                      (changeSelection)="updateForbiddenOrganizationsSelection($event)"></app-checkmarks>
      <app-checkbox formControlName="intraOrganizationMatching">Autoriser à ses collaborateurs entre eux ?
      </app-checkbox>
    </div>

    <div class="add-button relative">
      <app-button class="center-by-relative-parent" [disabled]="!formIsValid || nameTaken || loading" type="submit">Ajouter cette organisation
      </app-button>
    </div>
  </form>
</section>
